import { toArray } from 'rise-ui/utils/array.js';

export default function filterEmptyItemModels(items) {
  return toArray(items).filter(item =>
      item.isTimeSeries ? item.temporalStartDate
    : item.isGeospatial ? item.spatialOpenDataURL
    : item.isBinary     ? item.binaryFilePath
    : true
  );
}
